import { Button, HStack, Icon, Link as ExternalLink, Text, VStack } from '@oaknorth/component-core-v2';
import { Link } from '@oaknorth/util-routing';

import { useUtilities } from './features-hooks';
import { HomePageCard, HomePageCardType } from './HomePageCard';
import { UtilitiesSpec } from './types';

function Utility(props: UtilitiesSpec) {
  const { name, icon } = props;
  const content = (
    <VStack color="blue.500">
      <Icon as={icon} height={8} width={8} />
      <Text fontSize="lg">{name}</Text>
    </VStack>
  );

  if ('to' in props) {
    return <Link to={props.to as string}>{content}</Link>;
  }
  if ('href' in props) {
    return <ExternalLink href={props.href}>{content}</ExternalLink>;
  }
  return (
    <Button variant="link" onClick={props.onClick} fontWeight="normal">
      {content}
    </Button>
  );
}

export function Utilities() {
  const utilities = useUtilities();
  return (
    <HomePageCard type={HomePageCardType.FULL} height="full" justifyContent="center">
      <HStack
        padding={8}
        justifyContent="space-around"
        alignItems="center"
        width="full"
        data-testid="home-page-utilities-card"
        height="full"
      >
        {utilities.map(({ key, ...spec }) => {
          return <Utility {...spec} key={key} />;
        })}
      </HStack>
    </HomePageCard>
  );
}
